<script lang="ts">
	import voucherImage from "../../../../core/assets/voucher.jpg?w=200&webp&imagetools";
	import { VoucherValueType } from "../../../../core/schema/VoucherValueType.js";
	import { formatPrice } from "../../../../core/utils/formatPrice.js";
	import { nbspify } from "../../../../core/utils/nbspify.js";
	import { toDateMonthYearFormat } from "../../../../core/utils/toDateMonthYearFormat.js";
	import copy from "../../../../core/assets/icons/copy.svg?raw";
	import StaticPicture from "../Picture/StaticPicture.svelte";
	import Button from "../Button.svelte";
	import type { Voucher } from "../../../../core/schema/Voucher.js";
	import { getGlobalSettings } from "../../getGlobalSettings.js";

	export let voucher: Voucher;

	const globalSettings = getGlobalSettings();
	const { TENANT_LOCALE } = globalSettings;

	const { code, validTo } = voucher;
	const { type: valueType } = voucher.value;

	let copiedTimeout: number | undefined;
	function copyToClipboard(code: Voucher["code"]): void {
		if (code === undefined) {
			return;
		}
		void navigator.clipboard.writeText(code);
		if (copiedTimeout !== undefined) {
			clearTimeout(copiedTimeout);
		}
		copiedTimeout = window.setTimeout(() => {
			copiedTimeout = undefined;
		}, 1000);
	}
</script>

<div class="border-1 group rounded-2xl border-gray-200">
	<div class="w-full p-4 md:p-6">
		<div class="flex w-full flex-col gap-3 md:flex-row md:gap-4">
			<div class="flex gap-4">
				<StaticPicture
					alt="Voucher"
					image={voucherImage}
					width={200}
					height={200}
					imgClass="rounded-md w-[3.5rem] h-[3.5rem] md:w-full md:h-full"
				/>
				<div class="flex flex-col gap-2 md:hidden">
					<p class="font-semibold">Slevový kód</p>
					<p class="text-md flex justify-center rounded-md bg-gray-200 px-4 font-bold leading-6">
						{code}
					</p>
				</div>
			</div>
			<div class="flex w-full flex-col justify-between">
				<div class="flex w-full justify-between">
					<div class="hidden flex-col gap-2 md:flex">
						<p class="text-md font-semibold">Slevový kód</p>
						<p class="flex justify-center rounded-md bg-gray-200 px-4 text-lg font-bold">
							{code}
						</p>
					</div>
					<p class="hidden text-lg font-semibold lg:inline">
						{#if valueType === VoucherValueType.ValueOnly}
							{formatPrice(voucher.value.absolute, TENANT_LOCALE, false)}
						{:else if valueType === VoucherValueType.MaxValueAndPercentage}
							{nbspify(`${voucher.value.percentageValue} %`)}
							<small>{nbspify(`Až do částky ${formatPrice(voucher.value.maxAbsolute, TENANT_LOCALE, false)}`)}</small>
						{/if}
					</p>
				</div>
				<div class="flex w-full items-end justify-between md:items-baseline">
					<p class="text-2xs">
						{nbspify(`Platnost do ${toDateMonthYearFormat(validTo, TENANT_LOCALE)}`)}
					</p>
					<Button
						variant="primary"
						class="hidden lg:flex"
						icon={copy}
						iconClass="h-5 w-5"
						on:click={() => {
							copyToClipboard(code);
						}}
					>
						{nbspify(copiedTimeout !== undefined ? "Kód zkopírován" : "Zkopírovat kód")}
					</Button>
					<p class="text-md mt-2 font-semibold leading-6 lg:hidden">
						{#if valueType === VoucherValueType.ValueOnly}
							{formatPrice(voucher.value.absolute, TENANT_LOCALE, false)}
						{:else if valueType === VoucherValueType.MaxValueAndPercentage}
							{nbspify(`${voucher.value.percentageValue} %`)}
							<small>{nbspify(`Až do částky ${formatPrice(voucher.value.maxAbsolute, TENANT_LOCALE, false)}`)}</small>
						{/if}
					</p>
				</div>
			</div>
		</div>
	</div>
	<div class="border-t-1 flex justify-center border-gray-200 py-6 lg:hidden">
		<Button
			variant="primary"
			icon={copy}
			iconClass="h-5 w-5"
			on:click={() => {
				copyToClipboard(code);
			}}
		>
			{nbspify(copiedTimeout !== undefined ? "Kód zkopírován" : "Zkopírovat kód")}
		</Button>
	</div>
</div>
